import { formatMoney } from '@archetype-themes/scripts/helpers/currency'

let totalRequiredPrice = 0;

document.addEventListener("DOMContentLoaded", () => {
  totalRequiredPrice = calculateRequiredProducts();
  setupAddonToggles();
});

/**
 * Attach click handlers to the mattress "הוסף" buttons.
 * Each click toggles:
 *  - button .is-selected class
 *  - card .bundle-addon-selected class
 *  - hidden quantity input between "0" and "1"
 *  - recalculates the total bundle price
 */
function setupAddonToggles() {
  const buttons = document.querySelectorAll(".bundle-addon-toggle");
  if (!buttons.length) return;

  buttons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const card = btn.closest(".grid-item");
      if (!card) return;

      const qtyInput = card.querySelector(".quantity-selector__input");
      const qtyWrapper = card.querySelector(".quantity-selector-bundle");
      const plusBtn = qtyWrapper?.querySelector(".js-qty__adjust--plus");
      const minusBtn = qtyWrapper?.querySelector(".js-qty__adjust--minus");

      if (!qtyInput) return;

      const willSelect = !btn.classList.contains("is-selected");

      // Toggle UI
      btn.classList.toggle("is-selected", willSelect);
      card.classList.toggle("bundle-addon-selected", willSelect);

      // Toggle hidden quantity: 1 when selected, 0 when not
      qtyInput.value = willSelect ? "1" : "0";
      qtyInput.setAttribute("value", qtyInput.value);

      // Also click the hidden plus/minus, in case other logic listens to them
      if (willSelect) {
        plusBtn?.click();
      } else {
        minusBtn?.click();
      }

      calculateNotRequiredProducts();
    });
  });
}

/**
 * Update ALL bundle price UI elements (.bundle-price)
 */
function updatePriceDisplay(price) {
  const formattedPrice = formatMoney(
    price,
    "{" + "{" + "amount" + "}" + "}" + " ₪",
    true
  );

  const priceElements = document.querySelectorAll('.bundle-price');
  priceElements.forEach((el) => {
    el.innerHTML = formattedPrice;
  });
}

/**
 * Sum required (main) items once on load
 */
function calculateRequiredProducts() {
  let totalPrice = 0;
  const requiredProducts = document.querySelectorAll(
    '.grid-item.grid-product.required .product-grid-item'
  );

  requiredProducts.forEach((item) => {
    const price = Number(item.dataset.productBundlePrice) || 0;
    totalPrice += price;
  });

  updatePriceDisplay(totalPrice);
  return totalPrice;
}

function calculateNotRequiredProducts() {
  let totalPrice = totalRequiredPrice;
  const quantityInputs = document.querySelectorAll(
    ".bundle-addon-quantity .quantity-selector__input"
  );

  quantityInputs.forEach((input) => {
    const card = input.closest('.product-grid-item');
    const price = Number(card?.dataset.productBundlePrice) || 0;

    if (input.value === "1") {
      totalPrice += price;
    }
  });

  updatePriceDisplay(totalPrice);
}
document.addEventListener("click", function (e) {
  const thumb = e.target.closest("[data-bundle-thumb]");
  if (!thumb) return;

  // stop card link navigation
  e.preventDefault();
  e.stopPropagation();

  const card = thumb.closest(".grid-item, .bundle-card, .product-grid-item");
  if (!card) return;

  const mainImg = card.querySelector("[data-bundle-main-img]");
  const fullSrc = thumb.getAttribute("data-full-src");
  if (!mainImg || !fullSrc) return;

  mainImg.src = fullSrc;

  card.querySelectorAll("[data-bundle-thumb].is-active").forEach(x => x.classList.remove("is-active"));
  thumb.classList.add("is-active");
});

// keyboard support
document.addEventListener("keydown", function (e) {
  const thumb = e.target.closest("[data-bundle-thumb]");
  if (!thumb) return;
  if (e.key !== "Enter" && e.key !== " ") return;

  e.preventDefault();
  e.stopPropagation();
  thumb.click();
});

  // bundle story arrows
document.addEventListener('DOMContentLoaded', function () {
  const storiesNav = document.querySelector('.bundle-stories');
  if (!storiesNav) return;

  const track = storiesNav.querySelector('.bundle-stories__track');
  const prevBtn = storiesNav.querySelector('.bundle-stories__arrow--left');
  const nextBtn = storiesNav.querySelector('.bundle-stories__arrow--right');

  if (!track || !prevBtn || !nextBtn) return;

  const isRTL = document.documentElement.getAttribute('dir') === 'rtl';

  function getScrollAmount() {
    return 100;
  }

  function scrollTrack(direction) {
    let amount = getScrollAmount();

    if (direction === 'prev') {
      amount = -amount;
    }

    if (isRTL) {
      amount = -amount;
    }

    track.scrollBy({
      left: amount,
      behavior: 'smooth'
    });
  }

  prevBtn.addEventListener('click', function (e) {
    e.preventDefault();
    scrollTrack('prev');
  });

  nextBtn.addEventListener('click', function (e) {
    e.preventDefault();
    scrollTrack('next');
  });
});
